import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ReceiptIcon from '@mui/icons-material/Receipt';
import InventoryIcon from '@mui/icons-material/Inventory';
import AssessmentIcon from '@mui/icons-material/Assessment';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import BusinessIcon from '@mui/icons-material/Business';

const features = [
  {
    icon: <ReceiptIcon sx={{ fontSize: 40 }} />,
    title: 'Food Billing & Orders',
    description: 'Streamline your order processing with our intuitive POS system',
    benefits: [
      'Quick order entry with customizable modifiers',
      'Split billing and table management',
      'Multiple payment methods support',
      'Offline mode for uninterrupted service',
    ],
  },
  {
    icon: <InventoryIcon sx={{ fontSize: 40 }} />,
    title: 'Inventory Management',
    description: 'Keep track of your stock in real-time',
    benefits: [
      'Real-time stock tracking and alerts',
      'Automated reorder points',
      'Waste tracking and management',
      'Supplier management and ordering',
    ],
  },
  {
    icon: <AssessmentIcon sx={{ fontSize: 40 }} />,
    title: 'Invoice & Reporting',
    description: 'Make data-driven decisions with comprehensive reports',
    benefits: [
      'Tax-compliant billing system',
      'Customizable sales reports',
      'Employee performance tracking',
      'Financial analytics dashboard',
    ],
  },
  {
    icon: <TableRestaurantIcon sx={{ fontSize: 40 }} />,
    title: 'Table View',
    description: 'Manage your restaurant floor efficiently',
    benefits: [
      'Live table status monitoring',
      'Reservation management',
      'Waitlist handling',
      'Table turnover optimization',
    ],
  },
  {
    icon: <RestaurantMenuIcon sx={{ fontSize: 40 }} />,
    title: 'Menu Management',
    description: 'Update your menu with ease',
    benefits: [
      'Digital menu updates in real-time',
      'Seasonal menu planning',
      'Recipe and cost tracking',
      'Menu item performance analytics',
    ],
  },
  {
    icon: <BusinessIcon sx={{ fontSize: 40 }} />,
    title: 'Multi-location Support',
    description: 'Perfect for chains and franchises',
    benefits: [
      'Centralized management dashboard',
      'Location-specific settings',
      'Cross-location reporting',
      'Unified inventory management',
    ],
  },
];

function Features() {
  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          bgcolor: 'linear-gradient(90deg, #fff8ec 0%, #F9B233 100%)',
          color: '#234734',
          py: { xs: 8, md: 12 },
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h1"
            align="center"
            sx={{
              fontSize: { xs: '2.5rem', md: '3.5rem' },
              fontWeight: 700,
              mb: 2,
              color: '#234734',
              textShadow: '0 2px 8px rgba(249,178,51,0.08)',
            }}
          >
            Powerful Features for Modern Restaurants
          </Typography>
          <Typography
            variant="h5"
            align="center"
            sx={{ opacity: 0.9, color: '#234734' }}
          >
            Everything you need to run your restaurant efficiently
          </Typography>
        </Container>
      </Box>

      {/* Features Grid */}
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
        <Grid container spacing={4}>
          {features.map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card
                sx={{
                  height: '100%',
                  minHeight: 380,
                  display: 'flex',
                  flexDirection: 'column',
                  bgcolor: '#fff8ec',
                  border: '1.5px solid #F9B233',
                  boxShadow: '0 2px 12px rgba(249,178,51,0.06)',
                  p: 2,
                }}
              >
                <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      mb: 2,
                    }}
                  >
                    <Box sx={{ color: '#234734', mr: 2 }}>
                      {feature.icon}
                    </Box>
                    <Typography variant="h4" component="h2">
                      {feature.title}
                    </Typography>
                  </Box>
                  <Typography
                    variant="body1"
                    sx={{ color: '#234734', opacity: 0.8 }}
                    paragraph
                  >
                    {feature.description}
                  </Typography>
                  <List>
                    {feature.benefits.map((benefit, idx) => (
                      <ListItem key={idx} sx={{ py: 0.5 }}>
                        <ListItemIcon sx={{ minWidth: 36 }}>
                          <CheckCircleIcon sx={{ color: '#F9B233' }} />
                        </ListItemIcon>
                        <ListItemText primary={benefit} />
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default Features; 